import { Box, TextField, InputAdornment, useTheme } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { FilterDocuments } from './FilterDocuments';

export const SearchBar = ({ value, onChange, placeholder = "Buscar documento...", token, onFilterResult, onFilterLoading }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        width: '100%',
        mb: { xs: 2, sm: 3 },
      }}
    >
      <TextField
        variant="outlined"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        size="small"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="action" />
            </InputAdornment>
          ),
          sx: {
            borderRadius: "8px",
            backgroundColor: theme.palette.background.paper,
            width: { xs: '100%', sm: '300px' },
            "& fieldset": {
              borderColor: theme.palette.divider,
              transition: "border-color 0.2s ease",
            },
            "&:hover fieldset": {
              borderColor: theme.palette.primary.main,
            },
          },
        }}
      />

      <FilterDocuments 
        token={token} 
        onFilterResult={onFilterResult} 
        onFilterLoading={onFilterLoading} 
      />
    </Box>
  );
};
